'use client';

import styled from 'styled-components';

import type { HeadingFiveElementType } from '@zoomit/editor';
import { Typography } from '@zoomit/zoomit-ds';

interface RenderElementProps {
  children: any;
  element: HeadingFiveElementType;
  id?: string;
}

const HeadingFive = (props: RenderElementProps) => {
  const { children, element } = props;

  return (
    <HeadingFiveBase
      variant="h5"
      lineHeight={1.78}
      textAlign={element.annotations.textAlign}
      textDir={element.annotations.textDirection}
    >
      {children}
    </HeadingFiveBase>
  );
};

export default HeadingFive;

type HeadingFiveProps = {
  textAlign?: string;
  textDir?: string;
};

const HeadingFiveBase = styled(Typography)<HeadingFiveProps>`
  font-size: 1.6rem;
  margin: 0;
  text-align: ${({ textAlign }) => textAlign};
  direction: ${({ textDir }) => textDir};
`;
